import { Component, OnInit } from "@angular/core";
import { ColorFromId, LoaderService, Message } from "@stdoutsrl/design-kit";
import { BookingService } from "../../service/booking.service";
import { timetables } from "../../../assets/constants";
import { RestService } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-reminder",
  templateUrl: "./reminder.component.html",
  styles: [],
  standalone: false,
})
export class ReminderComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private booking: BookingService,
    private message: Message,
    private rest: RestService,
    private randomColorById: ColorFromId
  ) {}

  dataTable: any[] = [];
  mySalons: any[] = [];
  mySalon: any;

  ngOnInit(): void {
    this.getMySalons();
    // this.getReminders();
  }

  sendReminderWhatapp(event: any) {
    const date = new Date(event?.startDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedDate = `${day}/${month}/${year} - ${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}`;

    let whatappMessage = `✨ È il momento perfetto per dedicarti al tuo prossimo trattamento di ${event.itemName}!%0A%0AUn piccolo promemoria per te: è trascorso il tempo ideale per ripetere il trattamento e continuare a prenderti cura di te in modo costante.%0A%0A📲 Puoi prenotare comodamente con l’app EstetistApp oppure scriverci su WhatsApp. Noi siamo pronte ad accoglierti, come sempre, con professionalità e attenzione 💖%0A%0A📍 Centro Estetico ${this.mySalon?.name} - ${this.mySalon?.address} 📞 ${this.mySalon?.phoneNumber}`;
    window.open(
      `https://web.whatsapp.com/send?phone=${event?.phone}&text=${whatappMessage}`
    );
  }

  getMySalons() {
    this.loader.on();
    this.rest.get("/user/me/salon").subscribe({
      next: (value: any) => {
        this.mySalons = value;
        this.loader.off();
      },
      error: (error) => {},
    });
  }

  getReminders(salon: any) {
    this.loader.on();
    this.mySalon = salon;
    this.rest.get(`/booking/salon/${salon.id}/rebook-users`).subscribe({
      next: (value: any) => {
        this.dataTable = value.data;
        this.loader.off();
      },
      error: (error) => {},
    });
  }
}
